/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { CommsTemplatePageComponent } from "@src/app/modules/social/comms-template-page/comms-template-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const CommsTemplatePageNavRoute = new NavRoute('social/comms', ()=>CommsTemplatePageComponent, 'model_training').setViews(() => [{
    id: 'allTemplates',
    name: 'All Templates',
    helpText: 'All communication templates, with no type filter applied, sorted by title',
    filterFields: { type: null },
    sort: 'title',
}]);
